<template>
    <svg
        width="1042"
        height="400"
        viewBox="0 0 1042 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_415_979)">
            <g filter="url(#filter0_f_415_979)">
                <path
                    d="M721.195 -100H142.424H35C37.7353 -85.8486 72.065 -14.2764 124.899 15.6815C234.275 77.7005 235.261 21.8442 340.655 114.677C399.711 166.694 398.778 -1.71037 413.698 32.1897C425.634 59.3098 461.144 415.735 724.322 227.368C912.479 92.6957 854.941 -16.7424 806.849 -68.1916C785.085 -91.4741 753.065 -100 721.195 -100Z"
                    fill="url(#paint0_linear_415_979)"
                    fill-opacity="0.5"
                />
            </g>
            <g filter="url(#filter1_f_415_979)">
                <circle
                    cx="344"
                    cy="89"
                    r="91"
                    fill="url(#paint1_linear_415_979)"
                    fill-opacity="0.8"
                />
            </g>
            <g filter="url(#filter2_f_415_979)">
                <ellipse
                    cx="781.052"
                    cy="-31.9516"
                    rx="206.287"
                    ry="91"
                    transform="rotate(-15.4093 781.052 -31.9516)"
                    fill="url(#paint2_linear_415_979)"
                    fill-opacity="0.53"
                />
            </g>
        </g>
        <defs>
            <filter
                id="filter0_f_415_979"
                x="-29"
                y="-164"
                width="947.432"
                height="510.066"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feGaussianBlur
                    stdDeviation="32"
                    result="effect1_foregroundBlur_415_979"
                />
            </filter>
            <filter
                id="filter1_f_415_979"
                x="199"
                y="-56"
                width="290"
                height="290"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feGaussianBlur
                    stdDeviation="27"
                    result="effect1_foregroundBlur_415_979"
                />
            </filter>
            <filter
                id="filter2_f_415_979"
                x="526.695"
                y="-189.41"
                width="508.713"
                height="314.917"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feGaussianBlur
                    stdDeviation="27"
                    result="effect1_foregroundBlur_415_979"
                />
            </filter>
            <linearGradient
                id="paint0_linear_415_979"
                x1="-12.4248"
                y1="-156.805"
                x2="91.1369"
                y2="-342.235"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF8A48" />
                <stop offset="0.53125" stop-color="#FF5858" />
                <stop offset="1" stop-color="#D20B79" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_415_979"
                x1="259"
                y1="65.5"
                x2="344"
                y2="180"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF9548" />
                <stop
                    offset="0.515625"
                    stop-color="#FF176B"
                    stop-opacity="0.76"
                />
            </linearGradient>
            <linearGradient
                id="paint2_linear_415_979"
                x1="588.366"
                y1="-55.4516"
                x2="640.893"
                y2="104.947"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF9548" />
                <stop
                    offset="0.515625"
                    stop-color="#FF176B"
                    stop-opacity="0.76"
                />
            </linearGradient>
            <clipPath id="clip0_415_979">
                <rect width="1042" height="400" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
